import { useSelector } from 'react-redux/es/exports'
import { useLocation } from 'react-router-dom'
import { SvgIcon, SvgType } from '../../common/svgIcon/SvgIcon'
import routes from '../../routes'
import RouteLink from '../navbar/RouteLink'
import { SideBar } from './styled'

const Sidebar = () => {
  const location = useLocation()
  const { currentUser } = useSelector((state: any) => state.auth)

  return (
    <SideBar>
      {location.pathname.includes(routes.personal) ? (
        <h4 className="text-white mb-3">My Profile</h4>
      ) : (
        <h4 className="text-white mb-3">Sessions</h4>
      )}
      <div className="links">
        {location.pathname.includes(routes.personal) ? (
          <>
            <RouteLink route={routes.editProfile}>
              <span>
                <SvgIcon type={SvgType.EDITPROFILE} />
              </span>
              <span className="link-text">Edit Profile</span>
            </RouteLink>
          </>
        ) : (
          <>
            {currentUser && (
              <>
                {' '}
                <RouteLink route={routes.liveSessions}>
                  <span>
                    <SvgIcon type={SvgType.LIVESESSION} />
                  </span>
                  <span className="link-text">Live Sessions</span>
                </RouteLink>
                <div className="ms-3">
                  <RouteLink route={routes.keynote}>
                    <span>
                      <SvgIcon type={SvgType.KEYNOTE} />
                    </span>
                    <span className="link-text">Keynote Session</span>
                  </RouteLink>
                  <RouteLink route={routes.masterclass}>
                    <span>
                      <SvgIcon type={SvgType.MASTERCLASS} />
                    </span>
                    <span className="link-text">Masterclass</span>
                  </RouteLink>
                  <RouteLink route={routes.specialPresentation}>
                    <span>
                      <SvgIcon type={SvgType.PANEL} />
                    </span>
                    <span className="link-text">Special Presentation</span>
                  </RouteLink>
                  <RouteLink route={routes.otherSession}>
                    <span>
                      <SvgIcon type={SvgType.RECORDING} />
                    </span>
                    <span className="link-text">Other Sessions</span>
                  </RouteLink>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </SideBar>
  )
}

export default Sidebar
